import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["subGroup", "multi"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { cloneDeep, get, set } from "lodash";
import { required, minLength, requiredIf, email, between, maxValue, maxLength } from "vuelidate/lib/validators";
import { withValidDate, withPastDate, withFutureDate, minTimeAtGroup, withValidSin, requiredSin, customConditional } from "./validation-rules";
const minLengthValidation = {
  minLength: minLength(0)
};
export default class ApplicationValidationsGenerator {
  constructor(_schema, generatorOptions) {
    var _generatorOptions$ign, _generatorOptions$gen, _generatorOptions$ign2;
    _defineProperty(this, "defaultSchema", void 0);
    _defineProperty(this, "validations", void 0);
    _defineProperty(this, "togglers", void 0);
    _defineProperty(this, "targets", void 0);
    _defineProperty(this, "cardGroups", void 0);
    _defineProperty(this, "generatorOptions", void 0);
    _defineProperty(this, "isEmpty", obj => {
      for (const key in obj) {
        if (obj[key]) return false;
      }
      return true;
    });
    _defineProperty(this, "isArray", value => {
      return value && typeof value === "object" && value.constructor === Array;
    });
    _defineProperty(this, "isObject", value => {
      return value && typeof value === "object" && value.constructor !== Array;
    });
    _defineProperty(this, "populateColumns", (columns, metadata, flow, excluded = []) => {
      if (typeof columns === "string") {
        var _context;
        const {
          columns: populated,
          "group-title": groupTitle,
          "empty-by-default": defaultEmpty = false,
          multi = false
        } = metadata["group-rules"][columns];
        if (!populated) return;
        return _mapInstanceProperty(_context = _filterInstanceProperty(populated).call(populated, ({
          key
        }) => !_includesInstanceProperty(excluded).call(excluded, key))).call(_context, column => _objectSpread(_objectSpread({}, column), {}, {
          subGroup: columns,
          groupTitle,
          defaultEmpty,
          visible: column.visible[flow],
          validation: column.validation[flow],
          multi
        }));
      }
      return columns;
    });
    _defineProperty(this, "buildConditionalValidator", (column, validator) => {
      if (this.targets[column.key]) return customConditional({
        togglerKey: this.targets[column.key],
        currentKey: column.key,
        column: this.togglers[this.targets[column.key]]
      }, required);
      return validator;
    });
    _defineProperty(this, "buildSectionValidation", (column, options = {
      defaultEmpty: false,
      ignoreVisibility: false
    }) => {
      var _column$validation, _context3, _column$validation2;
      const {
        defaultEmpty
      } = options;
      (_column$validation = column.validation) == null ? void 0 : _column$validation.forEach(v => {
        var _context2;
        if (!_includesInstanceProperty(_context2 = this.validations.validations).call(_context2, v)) this.validations.validations.push(v);
      });
      if (!_includesInstanceProperty(_context3 = this.validations.types).call(_context3, column.type)) this.validations.types.push(column.type);
      if (!this.generatorOptions.ignoreVisibility && !options.ignoreVisibility && !column.visible) return {};
      const validationParser = (type, column) => {
        if (this.generatorOptions.ignoreRequired) return {};
        switch (type.toLowerCase()) {
          case "required":
            {
              return this.getRequiredValidation(column, defaultEmpty != null ? defaultEmpty : false);
            }
          case "number":
            {
              if (column.min && column.max) {
                return {
                  between: this.buildConditionalValidator(column, between(_parseInt(column.min), _parseInt(column.max)))
                };
              }
              if (column.min) {
                return {
                  minLength: this.buildConditionalValidator(column, minLength(_parseInt(column.min)))
                };
              }
              if (column.max) {
                return {
                  maxLength: this.buildConditionalValidator(column, maxLength(_parseInt(column.max)))
                };
              }
              return {};
            }
          case "email":
            {
              return {
                email: this.buildConditionalValidator(column, email)
              };
            }
          case "date-format":
            {
              return {
                withValidDate: this.buildConditionalValidator(column, withValidDate)
              };
            }
          case "past-date":
            {
              return {
                withPastDate: this.buildConditionalValidator(column, withPastDate)
              };
            }
          case "future-date":
            {
              return {
                withFutureDate: this.buildConditionalValidator(column, withFutureDate)
              };
            }
          case "sin":
            {
              return {
                withValidSin: this.buildConditionalValidator(column, withValidSin)
              };
            }
          case "phone-number":
            {
              return {
                maxLength: this.buildConditionalValidator(column, maxLength(14))
              };
            }
          case "rate":
            {
              return {
                between: this.buildConditionalValidator(column, between(0, 99.999))
              };
            }
          case "max-years":
            {
              return {
                maxValue: this.buildConditionalValidator(column, maxValue(30))
              };
            }
          case "max-months":
            {
              return {
                maxValue: this.buildConditionalValidator(column, maxValue(11))
              };
            }
          case "phone-number-ext":
            {
              return {};
            }
          case "percentage":
            {
              return {};
            }
          case "year-format":
            {
              return {};
            }
          default:
            {
              return {};
            }
        }
      };
      const validations = (_column$validation2 = column.validation) == null ? void 0 : _reduceInstanceProperty(_column$validation2).call(_column$validation2, (acc, current) => {
        acc = _objectSpread(_objectSpread({}, acc), validationParser(current, column));
        return acc;
      }, {});
      const typeValidations = validationParser(column.type, column);
      return _objectSpread(_objectSpread({}, validations), typeValidations);
    });
    _defineProperty(this, "getGroupValidations", (column, defaultEmpty) => {
      var _column$validation3;
      if (!this.generatorOptions.ignoreVisibility && !column.visible) return {};
      const validationParser = type => {
        switch (type) {
          case "job-years":
            {
              return {
                minTimeAtGroup: minTimeAtGroup("time-at-job")
              };
            }
          default:
            {
              return {};
            }
        }
      };
      const validations = (_column$validation3 = column.validation) == null ? void 0 : _reduceInstanceProperty(_column$validation3).call(_column$validation3, (acc, current) => {
        acc = _objectSpread(_objectSpread({}, acc), validationParser(current));
        return acc;
      }, {});
      const validationsObject = _objectSpread(_objectSpread({}, validations), defaultEmpty ? minLengthValidation : {});
      if (column.key === "addresses") {
        validationsObject.minTimeAtGroup = minTimeAtGroup("time-at");
      }
      return validationsObject;
    });
    _defineProperty(this, "buildPart", (element, flow) => {
      const schema = this.defaultSchema;
      const part = {};
      element.sections.forEach(section => {
        const {
          "empty-by-default": defaultEmpty = false
        } = schema.metadata["group-rules"][section.group] || {};
        const columns = this.populateColumns(section.columns, schema.metadata, flow);
        if (!this.generatorOptions.ignoreVisibility && !section.visible) return;
        columns == null ? void 0 : columns.forEach(_ref => {
          let {
              subGroup,
              multi
            } = _ref,
            column = _objectWithoutProperties(_ref, _excluded);
          const {
            multi: isMultiGroup,
            min = 1
          } = schema.metadata["group-rules"][section.group];
          if (isMultiGroup) {
            part[section.group] = _objectSpread(_objectSpread({}, this.getDefaultValidationObjectForArray(defaultEmpty, column)), part[section.group] || {});
            for (let i = 0; i < min; i++) {
              const type = {};
              if (subGroup) {
                if (multi) {
                  type[subGroup] = _objectSpread(_objectSpread({}, this.getDefaultValidationObjectForArray(defaultEmpty, column)), type[subGroup] || {});
                  type[subGroup].$each = _objectSpread(_objectSpread({}, type[subGroup].$each), {}, {
                    [column.key]: this.buildSectionValidation(column, {
                      defaultEmpty
                    })
                  });
                  this.addToValidationGroup(section, element, `${section.group}`);
                } else {
                  type[subGroup] = type[subGroup] || {};
                  type[subGroup][column.key] = this.buildSectionValidation(column, {
                    defaultEmpty
                  });
                  this.addToValidationGroup(section, element, `${section.group}`);
                }
              } else {
                type[column.key] = this.buildSectionValidation(column, {
                  defaultEmpty
                });
                this.addToValidationGroup(section, element, `${section.group}`);
              }
              part[section.group].$each = _objectSpread(_objectSpread({}, part[section.group].$each), type);
            }
          } else {
            if (!part[section.group]) {
              part[section.group] = {};
              if (subGroup && !part[section.group][subGroup]) {
                if (multi) {
                  part[section.group][subGroup] = this.getDefaultValidationObjectForArray(defaultEmpty, column);
                } else {
                  part[section.group][subGroup] = {};
                }
              }
            }
            if (subGroup) {
              if (multi) {
                part[section.group][subGroup].$each = _objectSpread(_objectSpread({}, part[section.group][subGroup].$each), {}, {
                  [column.key]: this.buildSectionValidation(column, {
                    defaultEmpty
                  })
                });
                this.addToValidationGroup(section, element, `${section.group}.${subGroup}`);
              } else {
                part[section.group][subGroup][column.key] = this.buildSectionValidation(column);
                this.addToValidationGroup(section, element, `${section.group}.${subGroup}.${column.key}`);
              }
            } else {
              if (multi) {
                part[section.group][column.key] = this.getDefaultValidationObjectForArray(defaultEmpty, column);
                part[section.group][column.key].$each = this.buildSectionValidation(column, {
                  defaultEmpty
                });
                this.addToValidationGroup(section, element, `${section.group}.${column.key}`);
              } else {
                part[section.group][column.key] = this.buildSectionValidation(column, {
                  defaultEmpty
                });
                this.addToValidationGroup(section, element, `${section.group}.${column.key}`);
              }
            }
          }
        });
      });
      return part;
    });
    _defineProperty(this, "buildAppValidations", flow => {
      const schema = this.defaultSchema;
      const application = {};
      this.togglers = this.buildSectionTogglers(flow);
      schema[flow].forEach(element => {
        var _context4;
        if (!this.generatorOptions.ignoreVisibility && !element.sections.some(section => section.visible)) return;
        if (element.multi) {
          application[element.key] = this.getDefaultValidationObjectForArray(false, element);
          application[element.key].$each = _objectSpread(_objectSpread({}, application[element.key].$each), this.buildPart(element, flow));
        } else {
          application[element.key] = this.buildPart(element, flow);
        }
        this.cardGroups[element.key] = _filterInstanceProperty(_context4 = this.cardGroups[element.key]).call(_context4, Boolean);
      });
      application["cardGroupValidations"] = this.cardGroups;
      return {
        application
      };
    });
    _defineProperty(this, "buildSectionTogglers", flow => {
      const sectionTogglers = {};
      const schema = this.defaultSchema;
      schema[flow].forEach(element => {
        sectionTogglers[element.key] = (() => {
          element.sections.forEach(section => {
            const columns = this.populateColumns(section.columns, schema.metadata, flow);
            const {
              toggler: targets,
              key,
              options
            } = (columns == null ? void 0 : _findInstanceProperty(columns).call(columns, column => column.toggler)) || {};
            const togglers = key ? {
              targets,
              key,
              options
            } : null;
            if (togglers && key) {
              var _togglers$targets;
              sectionTogglers[key] = togglers;
              (_togglers$targets = togglers.targets) == null ? void 0 : _togglers$targets.forEach(target => {
                this.targets[target] = key;
              });
            }
          });
        })();
      });
      return sectionTogglers;
    });
    this.defaultSchema = _schema;
    this.validations = {
      validations: [],
      types: []
    };
    this.togglers = {};
    this.targets = {};
    this.cardGroups = {};
    this.generatorOptions = {
      ignoreRequired: (_generatorOptions$ign = generatorOptions == null ? void 0 : generatorOptions.ignoreRequired) != null ? _generatorOptions$ign : false,
      generateGroupValidations: (_generatorOptions$gen = generatorOptions == null ? void 0 : generatorOptions.generateGroupValidations) != null ? _generatorOptions$gen : true,
      ignoreVisibility: (_generatorOptions$ign2 = generatorOptions == null ? void 0 : generatorOptions.ignoreVisibility) != null ? _generatorOptions$ign2 : false
    };
  }
  addToValidationGroup(section, element, dataPath) {
    if (this.generatorOptions.ignoreVisibility || section.visible) {
      const card = get(this.cardGroups, `${element.key}.${section.card - 1}`);
      if (card) {
        if (!_includesInstanceProperty(card).call(card, dataPath)) {
          card.push(dataPath);
        }
      } else {
        set(this.cardGroups, `${element.key}.${section.card - 1}`, [dataPath]);
      }
    }
  }
  getRequiredValidation(column, defaultEmpty) {
    const {
      type
    } = column;
    if (type === "address") {
      if (this.generatorOptions.ignoreRequired) return {
        line1: {},
        "street-number": {},
        "street-name": {},
        city: {},
        province: {},
        "postal-code": {}
      };
      return {
        line1: {
          required
        },
        "street-number": {
          required
        },
        "street-name": {
          required
        },
        city: {
          required
        },
        province: {
          required
        },
        "postal-code": {
          required
        }
      };
    }
    if (this.generatorOptions.ignoreRequired) {
      return {};
    }
    if (type === "sin") {
      return {
        requiredSin
      };
    }
    return defaultEmpty ? {
      required: this.buildConditionalValidator(column, requiredIf(vm => {
        return vm.groupSetVisible;
      }))
    } : {
      required: this.buildConditionalValidator(column, required)
    };
  }
  getDefaultValidationObjectForArray(defaultEmpty, column) {
    return _objectSpread({
      $each: {}
    }, this.getGroupValidations(column, defaultEmpty));
  }
  buildWidgetValidations() {
    const clonedSchema = cloneDeep(this.defaultSchema);
    const dataStructure = _reduceInstanceProperty(clonedSchema).call(clonedSchema, (schemaAcc, {
      key,
      sections
    }) => {
      schemaAcc[key] = _reduceInstanceProperty(sections).call(sections, (sectionsAcc, {
        columns
      }) => {
        sectionsAcc = _objectSpread(_objectSpread({}, sectionsAcc), _reduceInstanceProperty(columns).call(columns, (columnsAcc, column) => {
          columnsAcc[column.key] = this.buildSectionValidation(column, {
            ignoreVisibility: true
          });
          return columnsAcc;
        }, {}));
        return sectionsAcc;
      }, {});
      return schemaAcc;
    }, {});
    return dataStructure;
  }
}